import { useLoading } from "@/contexts/LoadingContext";
import HeaderBar from "@/components/HeaderBar";
import Navbar from "@/components/Navbar";
import { Helmet } from "react-helmet-async";

interface PageLayoutProps {
    title: string;
    heading?: string;
    action?: React.ReactNode;
    children: React.ReactNode;
  }
  
  export const PageLayout = ({
    title,
    action,
    children,
  }: PageLayoutProps) => {

    const { isLoading } = useLoading()
    
    return (
      <div className="page-container">
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <Navbar />
        <main className="page-main-content">
          <HeaderBar />
          <div className="page-content">

            <div className="flex justify-end mb-4">
              {action}
            </div>
  
            {!isLoading && (
              <div className="page-body-fade-in">
                  {children}
              </div>
            )}
          </div>
        </main>
      </div>
    );
};